import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, createFieldsGroups, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

const defaultItems: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Beneficiario", fontWeight: "bold", }],
    ["2a271413-f928-4fd7-b648-e5d3dc9aeba4", {}],
    ["f01b88ce-1300-48a9-9e4a-a542c3b9b361", {}],
    ["43fcb9f7-fa03-4452-a6a4-591aa1fff9c7", {}],
    ["9660b5e2-2325-4101-b3fe-e316e3ff20a1", {}],
    ["6fe7ea08-6360-4d02-8fe5-3da568536456", {}],
    ["791a596a-4cfa-479a-90bb-1d0f79c3d621", {}],
    ["3c7a2e47-5fc0-4e95-bcbf-0ee61d64a73d", {}],
    ["c25db4af-ac2f-4539-8490-735c10f388df", {}],
    ["0020fdeb-7776-4959-9ff2-198c2469eb27", {}],
    ["9e8e4349-5f9a-43e7-a048-856955040966", {}],
    ["90806065-0d4c-4818-a31e-05d691195368", {}],
    ["69becc7e-b21e-4fc6-8458-dff7f7ddcfa9", {}],
    ["a34fea12-f31b-44c2-b640-7c1c884e9a11", {}],
    ["e00cd1a2-7eaf-4e36-ab0a-97dfe49ec7bc", { showBorder: true }],
]);

const items = createFieldsGroups([], defaultItems);

export const defaultBeneficiaryInformation: Map<string, ConfirmationData> = new Map([
    ...items
]);

export const updateBeneficiaryInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const section = page.sections.find(section => section.section_id === "faef4b8f-c9e2-4459-b3fb-5d5fb7cd3dac");
    if (!section) {
        return cd;
    }
    const groups = section.groups.filter(group => group.group_id !== "8c5ca023-d962-4fea-a066-34cb08d50850").sort((a, b) => a.order - b.order);
    const updatedItems = createFieldsGroups(groups, defaultItems);

    const answersMap = createQuestionValueMap(page);
    return updateMapWithFields(mapToTupleArray(answersMap), new Map([...cd, ...updatedItems]));
}